import { QUIZ_LIMITS_REACHED_ERROR } from '@showbie-socrative/socrative-utils';

import { CreateQuizEventAdapter } from '~analytics/adapters/CreateQuizEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { PaywallDispatch } from '~teacher/components/PaywallDialog';
import { useImportQuizToPersonalBySpreadsheetMutation } from '~teacher/hook/useImportQuizToPersonalBySpreadsheetMutation';

import { isAxiosError } from '../../../../../api/isAxiosError';
import { QuizToastActions, apiToaster } from '../../toastActions';

interface UseImportQuizBySpreadsheetToPersonalParams {
  paywallDispatch: PaywallDispatch;
  parentId: number;
  onClose: () => void;
}

export function useImportQuizBySpreadsheetToPersonal({
  paywallDispatch,
  parentId,
  onClose,
}: UseImportQuizBySpreadsheetToPersonalParams) {
  const useImportQuizByExcelMutation =
    useImportQuizToPersonalBySpreadsheetMutation();

  const handleUploadExcelFile = (file: File) => {
    useImportQuizByExcelMutation.reset();
    useImportQuizByExcelMutation.mutate(
      { parentId, file },
      {
        onSuccess: () => {
          new CreateQuizEventAdapter({
            creation_method: 'excel',
          }).sendAnalytics();
          onClose();
        },
        onError: (error: unknown) => {
          if (isAxiosError(error)) {
            const data = error.response.data;

            if (data.code === QUIZ_LIMITS_REACHED_ERROR.code) {
              onClose();
              paywallDispatch({
                type: 'OPEN',
                touch: [
                  PaywallScreens.QuizListLimitReached,
                  PaywallScreens.QuizListAddQuiz,
                ],
              });
            }
          } else {
            apiToaster([], QuizToastActions.ERROR, error);
            throw new Error(error as any);
          }
        },
      }
    );
  };

  return {
    ...useImportQuizByExcelMutation,
    handleUploadExcelFile,
  };
}
